export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';

// Event Actions
export const LOAD_EVENTS = 'LOAD_EVENTS';
export const LOAD_EVENTS_SUCCESS = 'LOAD_EVENTS_SUCCESS';
export const LOAD_EVENT_DETAILS = 'LOAD_EVENT_DETAILS';
export const LOAD_EVENT_DETAILS_SUCCESS = 'LOAD_EVENT_DETAILS_SUCCESS';
export const LOAD_EVENT_DETAILS_FAILURE = 'LOAD_EVENT_DETAILS_FAILURE';

// Event Teams Settings
export const LOAD_EVENT_TEAM_SETTINGS = 'LOAD_EVENT_TEAM_SETTINGS';
export const LOAD_EVENT_TEAM_SETTINGS_SUCCESS = 'LOAD_EVENT_TEAM_SETTINGS_SUCCESS';
export const LOAD_EVENT_TEAM_SETTINGS_FAILURE = 'LOAD_EVENT_TEAM_SETTINGS_FAILURE';
export const UPDATE_EVENT_TEAM_SETTINGS_SUCCESS = 'UPDATE_EVENT_TEAM_SETTINGS_SUCCESS';
export const UPDATE_EVENT_TEAM_SETTINGS_FAILURE = 'UPDATE_EVENT_TEAM_SETTINGS_FAILURE';

// Event registrations
export const LOAD_REG_DETAILS = 'LOAD_REG_DETAILS';
export const LOAD_REG_DETAILS_SUCCESS = 'LOAD_REG_DETAILS_SUCCESS';
export const LOAD_REG_DETAILS_FAILURE = 'LOAD_REG_DETAILS_FAILURE';
export const LOAD_REG_REVIEW_DETAILS = 'LOAD_REG_REVIEW_DETAILS';
export const LOAD_REG_REVIEW_DETAILS_SUCCESS = 'LOAD_REG_REVIEW_DETAILS_SUCCESS';
export const SAVE_REG = 'SAVE_REG';
export const UPDATE_REG_SUCCESS = 'UPDATE_REG_SUCCESS';
export const CREATE_REG_SUCCESS = 'CREATE_REG_SUCCESS';
export const UPDATE_REG_FAILURE = 'UPDATE_REG_FAILURE';

export const LOAD_APPROVED_REG_LIST = 'LOAD_APPROVED_REG_LIST';
export const LOAD_APPROVED_REG_LIST_SUCCESS = 'LOAD_APPROVED_REG_LIST_SUCCESS';
export const LOAD_APPROVED_REG_LIST_FAILURE = 'LOAD_APPROVED_REG_LIST_FAILURE';


export const LOAD_TEAM_LIST = 'LOAD_TEAM_LIST';
export const LOAD_TEAM_LIST_SUCCESS = 'LOAD_TEAM_LIST_SUCCESS';
export const LOAD_TEAM_LIST_FAILURE = 'LOAD_TEAM_LIST_FAILURE';
export const SAVE_TEAM_SUCCESS = 'SAVE_TEAM_SUCCESS';
export const SAVE_TEAM_FAILURE = 'SAVE_TEAM_FAILURE';

// Club Actions
export const LOAD_CLUBS = 'LOAD_CLUBS';
export const LOAD_CLUBS_SUCCESS = 'LOAD_CLUBS_SUCCESS';
export const LOAD_CLUB_DETAILS = 'LOAD_CLUB_DETAILS';
export const LOAD_CLUB_DETAILS_SUCCESS = 'LOAD_CLUB_DETAILS_SUCCESS';
export const LOAD_CLUB_DETAILS_FAILURE = 'LOAD_CLUB_DETAILS_FAILURE';

// Club Actions
export const LOAD_CLUB_MEMBERS = 'LOAD_CLUB_MEMBERS';
export const LOAD_CLUB_MEMBERS_SUCCESS = 'LOAD_CLUB_MEMBERS_SUCCESS';
export const LOAD_MEMBER_DETAILS = 'LOAD_MEMBER_DETAILS';
export const LOAD_MEMBER_DETAILS_SUCCESS = 'LOAD_MEMBER_DETAILS_SUCCESS';
export const LOAD_CLUB_MEMBERS_FAILURE = 'LOAD_CLUB_MEMBERS_FAILURE';
export const UPDATE_MEMBER_DETAILS_SUCCESS = 'UPDATE_MEMBER_DETAILS_SUCCESS';
export const CREATE_MEMBER_DETAILS_SUCCESS = 'CREATE_MEMBER_DETAILS_SUCCESS';

// User Actions
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const LOAD_CURRENT_USER = 'LOAD_CURRENT_USER';
// List
export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const LOAD_USERS_FAILURE = 'LOAD_USERS_FAILURE';
// Current
export const LOAD_CURRENT_USER_SUCCESS = 'LOAD_CURRENT_USER_SUCCESS';
export const LOAD_CURRENT_USER_FAILURE = 'LOAD_CURRENT_USER_FAILURE';
// Details
export const LOAD_USER_DETAILS = 'LOAD_USER_DETAILS';
export const LOAD_USER_DETAILS_SUCCESS = 'LOAD_USER_DETAILS_SUCCESS';
export const LOAD_USER_DETAILS_FAILURE = 'LOAD_USER_DETAILS_FAILURE';
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS';
// Groups
export const LOAD_GROUPS = 'LOAD_GROUPS';
export const LOAD_GROUPS_SUCCESS = 'LOAD_GROUPS_SUCCESS';
export const LOAD_GROUPS_FAILURE = 'LOAD_GROUPS_FAILURE';
// // Update user
// export const UPDATE_USER = 'UPDATE_USER';
// export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
// export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

// Reports
export const LOAD_REPORT_DETAILS = 'LOAD_REPORT_DETAILS';
export const LOAD_REPORT_DETAILS_SUCCESS = 'LOAD_REPORT_DETAILS_SUCCESS';
export const LOAD_REPORT_DATA_SUCCESS = 'LOAD_REPORT_DATA_SUCCESS';
export const LOAD_TEAM_DETAILS_SUCCESS = 'LOAD_TEAM_DETAILS_SUCCESS';
export const LOAD_TEAMS_DETAILS_SUCCESS = 'LOAD_TEAMS_DETAILS_SUCCESS';
export const LOAD_REPORT_DETAILS_FAILURE = 'LOAD_REPORT_DETAILS_FAILURE';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/